var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-wrapper"},[(_vm.getRol =='student')?_c('AssignmentList',{attrs:{"Gosterim":`Gosterim`}}):_vm._e(),(_vm.getRol =='teacher')?_c('IAR'):_vm._e(),_c('LearningTools'),_c('Links',{attrs:{"Konum":1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }